export enum DeviceType {
  MagneticStripe,
  Barcode,
  CashDrawer,
}
